// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/DroidSans-Bold-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/DroidSans-webfont.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "droid_sansbold";
  src: local("DroidSans-Bold-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "droid_sansregular";
  src: local("DroidSans-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
}

ul[role=list],
ol[role=list] {
  list-style: none;
}

html:focus-within {
  scroll-behavior: smooth;
}

a:not([class]) {
  text-decoration-skip-ink: auto;
}

img,
picture,
svg,
video,
canvas {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  font-style: italic;
  background-repeat: no-repeat;
  background-size: cover;
}

input,
button,
textarea,
select {
  font: inherit;
}

@media (prefers-reduced-motion: reduce) {
  html:focus-within {
    scroll-behavior: auto;
  }
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
    transition: none;
  }
}
body,
html {
  height: 100%;
  scroll-behavior: smooth;
}

.report-container {
  display: block;
}

.info-title {
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  padding: 0.675rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1rem;
  margin: 1.25rem 0;
}
.info-title .info-left {
  display: block;
}
.info-title .info-left h4 {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 20px;
  font-weight: 700;
}
.info-title .info-left .category-name {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  color: #2f2f2f;
}

.main-score-content {
  display: flex;
  flex-flow: row wrap;
  gap: 1rem;
}
.main-score-content .item-category {
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  padding: 0.675rem;
  width: calc(20% - 1rem);
  flex: 1 1 auto;
}
.main-score-content .item-category h4 {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 16px;
}

.score-table-percentile {
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  padding: 0.675rem;
  padding: 0;
  margin: 1rem 0;
}

.metric-performance {
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);
  display: block;
  padding: 12px;
}
.metric-performance .box-sub-title {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 1rem;
  color: #2f2f2f;
  line-height: 1.2;
  margin-bottom: 0.875rem;
  display: flex;
}

.summary-container {
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);
  display: block;
  padding: 12px;
  margin: 1.5rem 0;
}
.summary-container .box-sub-title {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 1rem;
  color: #2f2f2f;
  line-height: 1.2;
  margin-bottom: 0.875rem;
  display: flex;
}

.custom-tabs.performance-tab {
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  padding: 0.675rem;
  border: 1px solid #e4e5e6;
  padding: 0;
}
.custom-tabs.performance-tab .tab-list {
  background-color: #f2f2f2 !important;
}
.custom-tabs.performance-tab .tab-list button {
  background-color: transparent !important;
  padding: 0.875rem 1.25rem;
}
.custom-tabs.performance-tab .tab-content {
  padding: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/mixins/fonts.scss","webpack://./src/pages/healthcard/HealthCardReport.scss","webpack://./src/assets/mixins/reset.scss","webpack://./src/assets/mixins/mixins.scss","webpack://./src/assets/mixins/colors.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,oGAAA;EAEA,mBAAA;EACA,kBAAA;ACAF;ADEA;EACE,gCAAA;EACA,+FAAA;EAEA,mBAAA;EACA,kBAAA;ACDF;ACbA;;;EAGE,sBAAA;ADeF;;ACZA;EACE,SAAA;EACA,UAAA;ADeF;;ACZA;;EAEE,gBAAA;ADeF;;ACZA;EACE,uBAAA;ADeF;;ACZA;EACE,8BAAA;ADeF;;ACZA;;;;;EAKE,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,4BAAA;EACA,sBAAA;ADeF;;ACZA;;;;EAIE,aAAA;ADeF;;ACZA;EACE;IACE,qBAAA;EDeF;ECbA;;;IAGE,qCAAA;IACA,uCAAA;IACA,sCAAA;IACA,gCAAA;IACA,gBAAA;EDeF;AACF;ACZA;;EAEE,YAAA;EACA,uBAAA;ADcF;;AA3EA;EACI,cAAA;AA8EJ;;AA5EA;EEIE,sBCJM;EDKN,qBAAA;EACA,yCAAA;EACA,iBAAA;EFLE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,aAAA;EACA,iBAAA;AAkFJ;AAjFI;EACI,cAAA;AAmFR;AAlFQ;EDeN,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EChBU,eAAA;EACA,gBAAA;AAuFZ;AArFQ;EDIN,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECLU,eAAA;EACA,cGhBC;AH0Gb;;AArFA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAwFJ;AAvFI;EEtBF,sBCJM;EDKN,qBAAA;EACA,yCAAA;EACA,iBAAA;EFqBM,uBAAA;EACA,cAAA;AA4FR;AA3FQ;EDNN,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECKU,eAAA;AAgGZ;;AA5FA;EEhCE,sBCJM;EDKN,qBAAA;EACA,yCAAA;EACA,iBAAA;EF+BE,UAAA;EACA,cAAA;AAkGJ;;AAhGA;EE1CE,sBCCM;EDAN,qBAAA;EACA,wCAAA;EF0CE,cAAA;EACA,aAAA;AAqGJ;AApGI;EDrBF,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EGNA,eAAA;EACA,cCrBW;EDsBX,gBAAA;EACA,uBAAA;EACA,aAAA;AFmIF;;AA3GA;EElDE,sBCCM;EDAN,qBAAA;EACA,wCAAA;EFkDE,cAAA;EACA,aAAA;EACA,gBAAA;AAgHJ;AA/GI;ED9BF,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EGNA,eAAA;EACA,cCrBW;EDsBX,gBAAA;EACA,uBAAA;EACA,aAAA;AFuJF;;AAtHA;EEtDE,sBCJM;EDKN,qBAAA;EACA,yCAAA;EACA,iBAAA;EFqDE,yBAAA;EACA,UAAA;AA4HJ;AA3HI;EACI,oCAAA;AA6HR;AA5HQ;EACI,wCAAA;EACA,yBAAA;AA8HZ;AA3HI;EACI,aAAA;AA6HR","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\r\n@font-face {\r\n  font-family: \"droid_sansbold\";\r\n  src: local(\"DroidSans-Bold-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@font-face {\r\n  font-family: \"droid_sansregular\";\r\n  src: local(\"DroidSans-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@mixin primeFont() {\r\n  font-family: \"Abril Fatface\", serif;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFont() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFontBold() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 500;\r\n  font-style: normal;\r\n}\r\n","@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@font-face {\n  font-family: \"droid_sansbold\";\n  src: local(\"DroidSans-Bold-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"droid_sansregular\";\n  src: local(\"DroidSans-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n}\n\nul[role=list],\nol[role=list] {\n  list-style: none;\n}\n\nhtml:focus-within {\n  scroll-behavior: smooth;\n}\n\na:not([class]) {\n  text-decoration-skip-ink: auto;\n}\n\nimg,\npicture,\nsvg,\nvideo,\ncanvas {\n  max-width: 100%;\n  height: auto;\n  vertical-align: middle;\n  font-style: italic;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html:focus-within {\n    scroll-behavior: auto;\n  }\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n    transition: none;\n  }\n}\nbody,\nhtml {\n  height: 100%;\n  scroll-behavior: smooth;\n}\n\n.report-container {\n  display: block;\n}\n\n.info-title {\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);\n  padding: 0.675rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 1rem;\n  margin: 1.25rem 0;\n}\n.info-title .info-left {\n  display: block;\n}\n.info-title .info-left h4 {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 20px;\n  font-weight: 700;\n}\n.info-title .info-left .category-name {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 18px;\n  color: #2f2f2f;\n}\n\n.main-score-content {\n  display: flex;\n  flex-flow: row wrap;\n  gap: 1rem;\n}\n.main-score-content .item-category {\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);\n  padding: 0.675rem;\n  width: calc(20% - 1rem);\n  flex: 1 1 auto;\n}\n.main-score-content .item-category h4 {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 16px;\n}\n\n.score-table-percentile {\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);\n  padding: 0.675rem;\n  padding: 0;\n  margin: 1rem 0;\n}\n\n.metric-performance {\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);\n  display: block;\n  padding: 12px;\n}\n.metric-performance .box-sub-title {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 1rem;\n  color: #2f2f2f;\n  line-height: 1.2;\n  margin-bottom: 0.875rem;\n  display: flex;\n}\n\n.summary-container {\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);\n  display: block;\n  padding: 12px;\n  margin: 1.5rem 0;\n}\n.summary-container .box-sub-title {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 1rem;\n  color: #2f2f2f;\n  line-height: 1.2;\n  margin-bottom: 0.875rem;\n  display: flex;\n}\n\n.custom-tabs.performance-tab {\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);\n  padding: 0.675rem;\n  border: 1px solid #e4e5e6;\n  padding: 0;\n}\n.custom-tabs.performance-tab .tab-list {\n  background-color: #f2f2f2 !important;\n}\n.custom-tabs.performance-tab .tab-list button {\n  background-color: transparent !important;\n  padding: 0.875rem 1.25rem;\n}\n.custom-tabs.performance-tab .tab-content {\n  padding: 1rem;\n}","*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nul[role=\"list\"],\r\nol[role=\"list\"] {\r\n  list-style: none;\r\n}\r\n\r\nhtml:focus-within {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\na:not([class]) {\r\n  text-decoration-skip-ink: auto;\r\n}\r\n\r\nimg,\r\npicture,\r\nsvg,\r\nvideo,\r\ncanvas {\r\n  max-width: 100%;\r\n  height: auto;\r\n  vertical-align: middle;\r\n  font-style: italic;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\ninput,\r\nbutton,\r\ntextarea,\r\nselect {\r\n  font: inherit;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  html:focus-within {\r\n    scroll-behavior: auto;\r\n  }\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n    scroll-behavior: auto !important;\r\n    transition: none;\r\n  }\r\n}\r\n\r\nbody,\r\nhtml {\r\n  height: 100%;\r\n  scroll-behavior: smooth;\r\n}\r\n","@import \"variables\", \"colors\", \"fonts\", \"reset\";\r\n\r\n@mixin boxWithShadow() {\r\n  background-color: $white;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 0 20px rgba(0, 0, 0, 13%);\r\n}\r\n@mixin brandScores() {\r\n  background-color: $white;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 12%);\r\n  padding: 0.675rem;\r\n}\r\n\r\n@mixin pageTitle() {\r\n  @include primeFont();\r\n  font-size: 2rem;\r\n  color: $primary-color;\r\n  line-height: 2.5rem;\r\n  margin-top: 0.5rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n@mixin boxSubTitle() {\r\n  @include secondaryFontBold;\r\n  font-size: 1rem;\r\n  color: $text-color;\r\n  line-height: 1.2;\r\n  margin-bottom: .875rem;\r\n  display: flex;\r\n}","$primary-color: #0d47a0;\r\n$primary-color-hover: #093373;\r\n$secondary-blue: #93cfff;\r\n$background-color: #f4f6fa;\r\n$white: #fff;\r\n$text-color: #2f2f2f;\r\n$text-dark-color: #072148;\r\n$table-stroke-color: #dfdfdf;\r\n$stroke-color: #949494;\r\n$input-stroke: #e4e8e9;\r\n$text-warning: #ed8b00;\r\n$text-danger: #cc3201;\r\n$text-success: #339900;\r\n$tooltip-bg: #0d47a0;\r\n$tooltip-color: #ffffff;\r\n$button-color: #ff6b00;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
